export const GOOD = 'good';
export const MAINTENANCE = 'maintenance';
export const WARNING = 'warning';
export const ERROR = 'error';
export const CRITICAL = 'critical';
